<template>
	<section>
		<div class="container">
			<slot />
		</div>
	</section>
</template>

<script>
export default {
	name: "IntroSectionText",
};
</script>

<style lang="scss" scoped>
@import "../sass/abstracts/mixins";

section {
	@include media-breakpoint-up(lg) {
		margin-top: -5rem;
	}

	@include media-breakpoint-only(md) {
		margin-top: 8rem;
	}

	@include media-breakpoint-down(sm) {
		margin-top: 0;
	}
}
</style>
